import Helper from '../../../models/Helper';

const URI = '/courses/:id/pre-register';

/**
 * @desc Helper allowing to manage current user preregistrations into courses.
 */
class CoursePreregistrationsHelper extends Helper {
  constructor(api) {
    super(api, URI);
  }

  /**
   * @desc Pre-register current connected user to given course.
   * @param {Number} courseId The ID of the course to pre-register.
   * @return {Promise} The promise handling the request.
   * @example
   * const response = await myClient.helpers.learningActivity.coursePreregistrations.create(123);
   */
  create(courseId) {
    const request = super.create({}, false);
    request.setRouteParam('id', `${courseId}`);

    return request.execute();
  }

  /**
   * @desc Cancel pre-registration to given course of current connected user.
   * @param {Number} courseId The ID of the course to stop pre-registration.
   * @return {Promise} The promise handling the request.
   * @example
   * const response = await myClient.helpers.learningActivity.coursePreregistrations.delete(123);
   */
  delete(courseId) {
    return super.delete(courseId);
  }
}

export default CoursePreregistrationsHelper;
